import { render, staticRenderFns } from "./BusinessProfile.html?vue&type=template&id=ac9bec0c&scoped=true&"
import script from "./BusinessProfile.vue?vue&type=script&lang=js&"
export * from "./BusinessProfile.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProfile.scss?vue&type=style&index=0&id=ac9bec0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9bec0c",
  null
  
)

export default component.exports